import React from 'react';
import styles from './index.module.scss';

interface Props {
  color?: string;
  size?: number;
  className?: string;
}

const RegisterIcon = ({ color = 'currentColor', size = 24 }: { color: string; size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'block' }}
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const FlyingEnvelope: React.FC<Props> = ({ color = '#e2231a', size = 24, className }) => {
  // color 默认为京东红，或者主题色
  return (
    <div className={`${styles.container} ${className || ''}`} style={{ width: size, height: size }}>
      {/* 主图标 */}
      <div className={styles.mainEnvelope}>
        <RegisterIcon color={color} size={size} />
      </div>
      
      {/* 飞出的图标效果 */}
      <div className={`${styles.flyingEnvelope} ${styles.fly1}`}>
        <RegisterIcon color={color} size={size} />
      </div>
      <div className={`${styles.flyingEnvelope} ${styles.fly2}`}>
        <RegisterIcon color={color} size={size} />
      </div>
    </div>
  );
};

export default FlyingEnvelope;
